import React from 'react';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';

const GrillCapacity = ({
  grillFeatureLabels,
  grillCapacity,
  maxTemp,
  pelletHopperCapacity,
  totalCookingSpace,
  totalWeight,
}) => {
  if (!grillFeatureLabels) return null;

  return (
    <>
      {grillCapacity && (
        <div className="tw-flex tw-flex-col tw-gap-x-6 tw-justify-center tw-my-10 sm:tw-flex-row tw-items-center sm:tw-items-stretch">
          {grillCapacity.map((x, i) => (
            <React.Fragment key={i}>
              <div className="tw-flex tw-flex-row tw-align-center sm:tw-flex-col">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={buildImageSrc(x.icon, 32, 0, 0)}
                  role="presentation"
                  alt=""
                  className="tw-h-10 tw-pr-3 sm:tw-pr-0"
                />

                <span>
                  <p className="tra-text-web-heading-6 tw-text-center tw-pr-2">{x.amount}</p>
                </span>
                <span>
                  <p className="tra-text-web-body-l tw-font-bold">{x.foodTitle}</p>
                </span>
              </div>
              {i < grillCapacity.length - 1 && (
                <div className="tw-flex tw-items-center">
                  <p className="tra-text-web-body-s tw-uppercase tw-font-bold">
                    {grillFeatureLabels.orText}
                  </p>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      <dl className="tw-grid tw-grid-cols-[2fr_1fr] tw-gap-x-8 tw-gap-y-2 tw-mb-10 tw-max-w-sm tw-mx-auto sm:tw-px-16 sm:tw-max-w-lg md:tw-max-w-md lg:tw-px-8">
        <dt>{grillFeatureLabels.totalCookingSpace}</dt>
        <dd className="tw-font-bold">{totalCookingSpace}</dd>
        <dt>{grillFeatureLabels.totalWeight}</dt>
        <dd className="tw-font-bold">{totalWeight}</dd>
        <dt>{grillFeatureLabels.hopperCapacity}</dt>
        <dd className="tw-font-bold">{pelletHopperCapacity}</dd>
        <dt>{grillFeatureLabels.maxTemp}</dt>
        <dd className="tw-font-bold">{maxTemp}</dd>
      </dl>
    </>
  );
};

export default GrillCapacity;
